import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import emptyFunction from 'react-utils/emptyFunction';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import TourContext from '../contexts/TourContext';
import handleCallback from '../lib/handleCallback';
import { deactivateTour } from '../lib/deactivateTour';

class UITourCancelButton extends PureComponent {
  render() {
    const {
      tour
    } = this.context;
    const {
      getTour,
      getStep
    } = tour;

    const _this$props = this.props,
          {
      beforeCancel,
      tourKey,
      onClick
    } = _this$props,
          buttonProps = _objectWithoutPropertiesLoose(_this$props, ["beforeCancel", "tourKey", "onClick"]);

    const handleClick = () => {
      handleCallback(beforeCancel, () => {
        if (typeof onClick === 'function') {
          onClick();
        }

        deactivateTour(tour, tourKey);
      }, {
        tourKey: tourKey || getTour(),
        stepKey: getStep()
      });
    };

    return /*#__PURE__*/_jsx(UIButton, Object.assign({
      use: "secondary"
    }, buttonProps, {
      onClick: handleClick
    }));
  }

}

UITourCancelButton.defaultProps = {
  beforeCancel: emptyFunction,
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "shepherd-react.cancel"
  })
};
UITourCancelButton.propTypes = {
  beforeCancel: PropTypes.func,
  children: PropTypes.node,
  onClick: PropTypes.func,
  tourKey: PropTypes.string
};
UITourCancelButton.contextType = TourContext;
export default UITourCancelButton;